import React, { useEffect } from 'react';
import DataPoliciesResponses from '../components/data_components/policies_responses/DataPoliciesResponses.jsx';
import DataSpecies from '../components/data_components/species/DataSpecies.jsx'




function DataPage(props) {
 



    useEffect(() => {
    
  }, [props.lang]);
 
 
   const isPolicies = props.argument === "policies-responses" ? true : false;
  
   if(isPolicies) {
    return <DataPoliciesResponses coverage="global" lang={props.lang}/> ;
   } else { 
    return <DataSpecies coverage="global" lang={props.lang}/>;
  }
     
    

}


  export default DataPage;